import * as React from "react";
import { useState, useEffect } from "react";
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";

const QuantityColumn = (props: any) => {
    const { t } = useTranslation();
    let partNumber = props?.partNumber;
    let childPartNumber = props.childPartNumber;
    let cartDetailId = props?.cartDetailId;
    let [count, setCount] = useState<any>(props?.quantity);

    useEffect(() => {
        if (props?.quantity && !props?.isCommon) {
            setCount(props?.quantity);
        }
    }, [props?.quantity])

    function incrementCount() {
        let cnt = count + 1;
        if (cnt <= 9999) {
            setCount(cnt);
            if (props?.isCommon) {
                props?.onQuantityChange(cnt, props?.partId)
            } else {
                props?.updateCartQuantity(cartDetailId,partNumber, childPartNumber, cnt);
            }
        }
    }

    function decrementCount() {
        if (count === 1) {
            setCount(1);
        } else {
            let cnt = count - 1;
            setCount(cnt);
            if (props?.isCommon) {
                props?.onQuantityChange(cnt, props?.partId)
            } else {
                props?.updateCartQuantity(cartDetailId,partNumber, childPartNumber, cnt, props?.quantity);
            }
        }
    }

    const handleQntChange = (event: any) => {
        const value = event.target.value;
        const regex = /^\d+$/;
        if (value > 9999) {
            setCount(9999);
        } else if (regex.test(value) || !value) {
            setCount(value);
        } else {
            const qty = count;
            setCount(qty)
        }
    }

    const handleQntOnBlur = (event: any) => {
        const value = parseInt(event.target.value);
        if (value <= 0) {
            setCount(1);
            if (props?.isCommon) {
                props?.onQuantityChange(1, props?.partId)
            } else {
                props?.updateCartQuantity(cartDetailId,partNumber, childPartNumber, 1, props?.quantity);
            }
        }
        else if (value > 9999) {
            setCount(9999);
            if (props?.isCommon) {
                props?.onQuantityChange(9999, props?.partId)
            } else {
                props?.updateCartQuantity(cartDetailId,partNumber, childPartNumber, 9999, props?.quantity);
            }
        }
        else {
            let cnt = isNaN(value) ? 1 : value;
            setCount(cnt);
            if (props?.isCommon) {
                props?.onQuantityChange(cnt, props?.partId)
            } else {
                props?.updateCartQuantity(cartDetailId,partNumber, childPartNumber, cnt, props?.quantity);
            }
        }
    }

    return (
        <div className="quantity-value">
            <span onClick={decrementCount} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_SC_Partlist_Decrease)} className="quantity_minus">-</span>
            <span><input type="text" className="textfield" onBlur={handleQntOnBlur} onChange={handleQntChange} value={count}></input></span>
            <span onClick={incrementCount} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_SC_Partlist_Increase)} className="quantity_plus">+</span>
        </div>
    )
}

export default QuantityColumn